import React, { FC, useRef } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { VideoCarouselItem } from './VideoCarouselItem'
import { useWheelScroll } from 'utils/hooks/useWheelScroll'

import styles from './styles.module.scss'


const carouselVideos = [
  {
    videoUrl: 'https://youtu.be/gBuM3n0jDNM',
    posterUrl: 'https://img.youtube.com/vi/gBuM3n0jDNM/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/WyLib4iiIg4',
    posterUrl: 'https://img.youtube.com/vi/WyLib4iiIg4/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/7U1lBNZmSTU',
    posterUrl: 'https://img.youtube.com/vi/7U1lBNZmSTU/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/Ble2z9qFnys',
    posterUrl: 'https://img.youtube.com/vi/Ble2z9qFnys/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/35UEZrmmOOk',
    posterUrl: 'https://img.youtube.com/vi/35UEZrmmOOk/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/eEWPbsAiUN0',
    posterUrl: 'https://img.youtube.com/vi/eEWPbsAiUN0/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/hkfozn8knQY',
    posterUrl: 'https://img.youtube.com/vi/hkfozn8knQY/sddefault.jpg'
  },
  {
    videoUrl: 'https://youtu.be/VWbSUrmnVH4',
    posterUrl: 'https://img.youtube.com/vi/VWbSUrmnVH4/sddefault.jpg'
  }
]

interface IProps {
  playingVideo: string
  onClick: (value: string) => void
}

export const VideoCarousel: FC<IProps> = ({ playingVideo, onClick }) => {
  const videoCarouselRef = useRef<HTMLDivElement | null>(null)

  useWheelScroll(videoCarouselRef.current)

  return (
    <div ref={videoCarouselRef} className={styles.videoCarouselBlock}>
      {carouselVideos.map(item => <VideoCarouselItem key={item.videoUrl}
                                                     videoUrl={item.videoUrl}
                                                     posterUrl={item.posterUrl}
                                                     playingVideoUrl={playingVideo}
                                                     onClick={onClick}/>)}
    </div>
  )
}
